import { Record } from 'immutable';

const {
    GET_DASHBOARD_STATS_REQUEST,
    GET_DASHBOARD_STATS_SUCCESS,
    GET_DASHBOARD_STATS_FAILURE,
} = require('./dashboardActions').constants;

const InitialState = Record({
    isFetching: false,
    error: null,
    stats: {
        customers: 0,
        customers_active: 0,
        customers_inactive: 0,
        orders: 0,
        carehomes: 0,
        practices: 0
    }
});

const initialState = new InitialState();

/**
 * ## dashboardReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function dashboardReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.merge(state);

    switch (type) {
    case GET_DASHBOARD_STATS_REQUEST:
        return state.set('isFetching', true).set('error', null);

    case GET_DASHBOARD_STATS_SUCCESS:
        return state.set('isFetching', false).set('stats', payload);

    case GET_DASHBOARD_STATS_FAILURE:
        return state.set('error', payload).set('isFetching', false);

    default:
        return state;
    }
}
